function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
var defaultMeta = {
    category: "Presentation",
    cost: 10000,
    eliminations: false,
    registerVictory: true,
    forPoster: true,
    canUpdateAppearances: true,
    canUpdateChampionships: false,
    canUpdateFeuds: false,
    // new levers
    canUpdateDuration: true,
    defaultDuration: 60 * 3,
    minAppearances: 0,
    maxAppearances: 40
};
export var MIN_SEGMENTS_PER_PRODUCTION = 2;
export var PROMO_KEYS = [
    "PROMO",
    "DEBUT_PROMO"
];
var COMPETITION_DEFAULTS = {
    category: "Competition",
    cost: 10000,
    canUpdateFeuds: true,
    registerVictory: true,
    minAppearances: 2,
    forPoster: true,
    canUpdateChampionships: true,
    canUpdateAppearances: true
};
var PRESENTATION_DEFAULTS = {
    category: "Presentation",
    registerVictory: false,
    forPoster: false,
    cost: 5000,
    canUpdateChampionships: false,
    canUpdateAppearances: true,
    canUpdateFeuds: true
};
var CHANGES_DEFAULTS = {
    category: "Change",
    cost: 20000,
    forPoster: false,
    registerVictory: false,
    canUpdateAppearances: true,
    canUpdateChampionships: false,
    canUpdateFeuds: false
};
var TRANSITION_DEFAULTS = {
    category: "Transition",
    cost: 5000,
    forPoster: false,
    registerVictory: false,
    canUpdateAppearances: false,
    canUpdateChampionships: false
};
var COMPETITIONS = [
    {
        type: "BRAWL",
        name: "Brawl",
        cost: 5500
    },
    {
        type: "WARGAMES",
        name: "War Games",
        cost: 400000,
        canUpdateFeuds: true
    },
    {
        type: "LAST_MAN_STANDING_MATCH",
        name: "Last man standing",
        cost: 50000,
        canUpdateFeuds: true
    },
    {
        type: "IRON_MAN_MATCH",
        name: "Iron man match",
        cost: 70000,
        canUpdateFeuds: true
    },
    {
        type: "SUBMISSION_MATCH",
        name: "Submission match",
        cost: 45000,
        canUpdateFeuds: true
    },
    {
        type: "NO_HOLD_BARRED_MATCH",
        name: "No holds barred match",
        cost: 100000,
        canUpdateFeuds: true
    },
    {
        type: "BLOODBATH_MATCH",
        name: "Bloodbath match",
        cost: 50000,
        canUpdateFeuds: true
    },
    {
        type: "CAGE_MATCH",
        name: "Cage match",
        cost: 100000,
        canUpdateFeuds: true
    },
    {
        type: "DARK_MATCH",
        name: "Dark Match",
        cost: 2000,
        canUpdateFeuds: true
    },
    {
        type: "OPEN_CHALLENGE",
        name: "Open Challenge",
        cost: 50000
    },
    {
        type: "RUMBLE",
        name: "Rumble",
        cost: 1000000,
        eliminations: true
    },
    {
        type: "DEFAULT",
        name: "Match"
    },
    {
        type: "AMBULANCE",
        name: "Ambulance"
    },
    {
        type: "SPECIAL_GUEST_REF",
        name: "Special Referee",
        minAppearances: 3
    },
    {
        type: "TLC",
        name: "TLC"
    },
    {
        type: "EXTREME_RULES",
        name: "Extreme Rules",
        cost: 30000
    },
    {
        type: "HELL_IN_A_CELL",
        name: "Hell in a Cell",
        cost: 100000
    },
    {
        type: "TITLE_MATCH",
        name: "Title Match",
        cost: 20000
    },
    {
        type: "ELIMINATION_CHAMBER",
        name: "Elimination Chamber",
        cost: 300000
    },
    {
        type: "CASKET_MATCH",
        name: "Casket Match",
        cost: 150000
    },
    {
        type: "BACKSTAGE_BRAWL",
        name: "Backstage brawl",
        forPoster: false,
        cost: 25000
    },
    {
        type: "TAG_TEAM_MATCH",
        name: "Tag Team Match",
        cost: 18000,
        canUpdateFeuds: true
    },
    {
        type: "GRUDGE_MATCH",
        name: "Grudge Match"
    },
    {
        type: "LADDER_MATCH",
        name: "Ladder Match",
        cost: 50000
    },
    {
        type: "STREET_FIGHT",
        name: "Street Fight",
        cost: 50000
    },
    {
        type: "BATTLE_ROYAL",
        name: "Battle Royal",
        cost: 50000
    }
];
var PRESENTATIONS = [
    {
        type: "INTRODUCTION",
        name: "Show Introduction",
        canUpdateAppearances: false,
        canUpdateFeuds: false
    },
    {
        type: "COMMENTATORS_TABLE",
        name: "Commentators Table",
        canUpdateAppearances: false,
        canUpdateFeuds: false
    },
    {
        name: "Show Closing",
        type: "SHOW_CLOSING",
        canUpdateAppearances: false,
        canUpdateFeuds: false
    },
    {
        name: "Show Opening Video",
        type: "SHOW_OPENING_VIDEO",
        cost: 20000,
        canUpdateAppearances: false,
        canUpdateFeuds: false
    },
    {
        type: "NATIONAL_ANTHEM",
        name: "National Anthem",
        cost: 15000,
        canUpdateAppearances: false,
        canUpdateFeuds: false
    },
    {
        type: "PYRO",
        name: "Pyro",
        cost: 200000,
        canUpdateAppearances: false,
        canUpdateFeuds: false
    },
    {
        type: "INTERVIEW",
        name: "Interview",
        cost: 15000,
        canUpdateAppearances: true,
        canUpdateFeuds: true
    },
    {
        type: "PROMO",
        name: "Promo",
        cost: 20000,
        canUpdateAppearances: true,
        canUpdateFeuds: true
    },
    {
        type: "ANNOUNCEMENT",
        name: "Announcement",
        cost: 40000,
        forPoster: true,
        canUpdateAppearances: true,
        canUpdateFeuds: true
    },
    {
        type: "CONTRACT_SIGNING",
        name: "Contract signing",
        cost: 50000,
        forPoster: true,
        canUpdateAppearances: true,
        canUpdateFeuds: true
    },
    {
        type: "DEBUT_PROMO",
        name: "Debut Promo",
        cost: 100000,
        forPoster: true,
        canUpdateAppearances: true,
        canUpdateFeuds: true
    },
    {
        type: "TALK_SHOW",
        name: "Talk Show",
        cost: 7000,
        forPoster: true,
        canUpdateFeuds: true
    },
    {
        type: "TRIBUTE",
        name: "Tribute to",
        cost: 25000,
        forPoster: true,
        canUpdateAppearances: true
    },
    {
        type: "MATCH_MAKING",
        name: "Interrupted Promo",
        cost: 15000,
        canUpdateAppearances: true,
        canUpdateFeuds: true
    },
    {
        type: "CHAMPIONSHIP_CELEBRATION",
        name: "Championship Celebration",
        cost: 100000,
        forPoster: true,
        canUpdateAppearances: true,
        canUpdateFeuds: true
    },
    {
        type: "TRAINING_MONTAGE",
        name: "Training Montage",
        forPoster: true,
        cost: 75000,
        canUpdateAppearances: true
    },
    {
        type: "AWARD_CEREMONY",
        name: "Award Ceremony to",
        cost: 50000,
        forPoster: true,
        canUpdateAppearances: true
    },
    {
        type: "SPECIAL_GUEST_APPEARANCE",
        name: "Special Guest Appearance",
        cost: 50000,
        forPoster: true,
        canUpdateAppearances: true
    },
    {
        type: "COMEDY_SKIT",
        name: "Comedy Skit",
        cost: 30000,
        canUpdateAppearances: true
    },
    {
        type: "FAN_INTERACTION",
        name: "Fan Interaction",
        forPoster: true,
        canUpdateAppearances: true
    },
    {
        type: "PRESS_CONFERENCE",
        name: "Press Conference",
        forPoster: true,
        canUpdateAppearances: true,
        canUpdateFeuds: true,
        cost: 200000
    },
    {
        type: "PUBLIC_APPEARANCE_CLIP",
        name: "Public Appearance Clip",
        canUpdateAppearances: true,
        canUpdateFeuds: true,
        cost: 5000
    },
    {
        type: "VIDEO_PACKAGE",
        name: "Video Package",
        canUpdateAppearances: true,
        cost: 40000
    },
    {
        type: "PRE_DEBUT_PACKAGE",
        name: "Pre-debut Package",
        canUpdateAppearances: true,
        cost: 5000
    }
];
var CHANGES = [
    {
        type: "RETIREMENT",
        name: "Retirement of"
    },
    {
        type: "ALIGNMENT_CHANGE",
        name: "Alignment Change"
    }
];
var TRANSITIONS = [
    {
        type: "RECAP",
        name: "Recap"
    },
    {
        type: "ADVERT",
        name: "Advert",
        canUpdateDuration: false,
        defaultDuration: 60 * 3,
        cost: 0
    }
];
export var SegmentsMetaCollection = _to_consumable_array(COMPETITIONS.map(function(item) {
    return _object_spread({}, COMPETITION_DEFAULTS, item);
})).concat(_to_consumable_array(PRESENTATIONS.map(function(item) {
    return _object_spread({}, PRESENTATION_DEFAULTS, item);
})), _to_consumable_array(TRANSITIONS.map(function(item) {
    return _object_spread({}, TRANSITION_DEFAULTS, item);
})), _to_consumable_array(CHANGES.map(function(item) {
    return _object_spread({}, CHANGES_DEFAULTS, item);
}))).map(function(item) {
    return _object_spread_props(_object_spread({}, defaultMeta, item), {
        key: item.type
    });
});
export var SegmentsMeta = SegmentsMetaCollection.reduce(function(acc, segment) {
    acc[segment.type] = segment;
    return acc;
}, {});
export var SegmentTypes = _object_spread({}, Object.keys(SegmentsMeta));
